import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M15.34 16.398c.332.094.526.44.432.772a22.52 22.52 0 0 1-1.534 3.954.625.625 0 0 1-1.118-.56 21.253 21.253 0 0 0 1.449-3.734.626.626 0 0 1 .771-.432ZM12 10.375c.345 0 .625.28.625.625a18.54 18.54 0 0 1-2.849 9.904.626.626 0 0 1-1.059-.666A17.291 17.291 0 0 0 11.375 11c0-.345.28-.625.625-.625Z"
    />
    <path
      fill="currentColor"
      d="M12 6.375A4.625 4.625 0 0 1 16.625 11a22.77 22.77 0 0 1-.21 3.085.625.625 0 0 1-1.238-.17c.13-.953.198-1.926.198-2.915a3.375 3.375 0 0 0-6.75 0 14.542 14.542 0 0 1-2.28 7.85.626.626 0 0 1-1.076-.64A13.29 13.29 0 0 0 7.374 11 4.625 4.625 0 0 1 12 6.375Z"
    />
    <path
      fill="currentColor"
      d="M12 2.375A8.625 8.625 0 0 1 20.625 11a26.64 26.64 0 0 1-1.015 7.303.625.625 0 1 1-1.202-.342c.63-2.211.967-4.546.967-6.961A7.375 7.375 0 0 0 8.312 4.611a.625.625 0 0 1-.625-1.082A8.59 8.59 0 0 1 12 2.375ZM4.529 6.688a.625.625 0 0 1 1.082.625A7.34 7.34 0 0 0 4.625 11a10.59 10.59 0 0 1-1.063 4.638.626.626 0 0 1-1.125-.547A9.34 9.34 0 0 0 3.375 11c0-1.57.42-3.043 1.154-4.313Z"
    />
  </svg>
`;
